import type { SearchableSelectConfig } from '@/components/SearchableSelect';

export const REPORT_QUICK_FILTERS: SearchableSelectConfig[] = [
  {
    field: 'status',
    title: 'Status',
    config: {
      searchable: true,
      showCounts: true,
      variant: 'buttongroup'
    },
    filterOptions: [
      {
        label: 'Daily',
        value: 'Daily',
        id: 1
      },
      {
        label: 'Weekly',
        value: 'Weekly',
        id: 2
      },
      {
        label: 'Monthly',
        value: 'Monthly',
        id: 3
      },
      {
        label: 'Custom',
        value: 'Custom',
        id: 4
      }
    ]
  }
];

export enum REPORT_TYPE_ID {
  MDR = 1,
  EXEC = 2,
  VMP = 3,
  EDR = 4
}
